import React, { useState, useRef } from "react";
import { KendoTreeTable } from "../../Kendo/kendo_treetable";
import { KendoDatePicker } from "../../Kendo/kendo_datepicker";
import { KendoEditor } from "../../Kendo/kendo_editor";
import {
  Button,
  confirmDelete,
  ErrorMsg,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import { KendoDropdown } from "../../Kendo/kendo_dropdown";
import { baseURL } from "../../Util/axios_helper";
import { KendoLoader } from "../../Kendo/kendo_loader";
import { toast } from "react-toastify";
export const Blog = () => {
  const [error, setError] = useState({});
  const [refreshflag, setrefreshflag] = useState(0);
  const [title, setTitle] = useState("");
  const modalRef = useRef(null);
  const [editVisible, setEditVisible] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [DescFlag, setDescFlag] = useState(false);

  const [Blog, setBlog] = useState({
    BlogsID: 0,

    DisplayedInID: 0,
    DisplayedInName: "",
    BallroomID: 0,
    BallroomName: "",
    Title: "",
    Description: "",
    Image: "",
    EventDate: "",
    OldimagePath: "",
  });
  const Parentscolumns = [
    {
      field: "displayedInID",
      filterable: false,
      hidden: true,
    },

    {
      field: "eventName",
      title: "Displayed In",
      template: (e) => {
        return e.eventName === "BabyShower" ? "Baby Shower" : e.eventName;
      },
    },
  ];

  const childColumn = [
    {
      field: "blogsID",
      hidden: true,
    },
    {
      field: "displayedInID",
      hidden: true,
    },
    {
      field: "ballroomID",
      filterable: false,
      hidden: true,
    },
    {
      field: "displayedInName",
      hidden: true,
    },
    {
      field: "ballroomName",
      hidden: true,
    },
    {
      field: "title",
      title: "Title",
    },
    {
      field: "description",
      title: "Description",
      template: function (e) {
        const maxLength = 50;

        const stripHtmlTags = (input) => {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = input || "";
          return tempDiv.textContent || tempDiv.innerText || "";
        };

        const plainTextDescription = stripHtmlTags(e.description);

        const truncatedDescription =
          plainTextDescription.length > maxLength
            ? `${plainTextDescription.substring(0, maxLength)}...`
            : plainTextDescription;

        return `<div>${truncatedDescription}</div>`;
      },
    },

    {
      field: "eventDate",
      title: "Date",
      template: function (e) {
        return `<div>${new Date(e.eventDate).toLocaleDateString(
          "en-US"
        )}</div>`;
      },
    },

    {
      template: function (e) {
        if (e.imagePath) {
          return `<img src="${ImageURL}${e.imagePath}" width="40px" height="40px" />`;
        }
        return "";
      },
      title: "Image",
    },
  ];
  const clearForm = () => {
    setLoading(false);
    setDescFlag(false);
    $("#hide").click();
    setBlog({
      BlogsID: 0,
      DisplayedInID: 0,
      DisplayedInName: "",
      BallroomID: 0,
      BallroomName: "",
      Title: "",
      Description: "",
      Image: "",
      EventDate: "",
      OldimagePath: "",
    });
    setError({});
    setEditVisible(false);
    const form = document.getElementById("event-form");
    if (form) {
      form.reset();
    }
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    let oversize = false;
    oversize = Blog.Image?.size > maxSizeInBytes;

    const err = ValidateForm(e);

    const strippedValue = Blog.Description.replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();
    const sanitizedValue = /^[\s\n]*$/.test(strippedValue);

    setDescFlag(sanitizedValue);

    if (err) {
      setError(err);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: oversize,
      }));
    } else if (!oversize && !sanitizedValue) {
      setLoading(true);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
      }));
      setError((prev) => ({ ...prev, Description: false }));
      const formData = new FormData();
      formData.append("BlogsID", Blog.BlogsID);
      formData.append("DisplayedInID", Blog.DisplayedInID);
      formData.append("BallroomID", Blog.BallroomID);
      formData.append("Title", Blog.Title);
      formData.append("Description", Blog.Description || "");
      formData.append(
        "EventDate",
        Blog.EventDate
          ? new Date(Blog.EventDate).toISOString()
          : new Date().toISOString()
      );
      formData.append("OldimagePath", Blog.OldimagePath);
      formData.append("SavedBy", sessionUser());

      if (Blog.Image) {
        formData.append("Image", Blog.Image);
      }

      try {
        await corepost(
          "Blog/InsertUpdateBlog",
          formData,
          true,
          true,
          false,
          false
        );
        refreshChildGrd();
        clearForm();
        $("#blog-cancel").click();
      } catch (error) {
        console.error("Error while submitting the form:", error);
      }
    }
  };

  const onEditClick = (e) => {
    setTitle(e.eventName);
    setBlog((prevBlog) => ({
      ...prevBlog,
      DisplayedInID: e.displayedInID,
    }));
    $("#add_Blog").modal("show");
  };

  const handleDateChange = (e) => {
    const selectedDate = e ? e.toISOString() : null;
    if (selectedDate == null) {
      setBlog((prev) => ({
        ...prev,
        EventDate: null,
      }));
      setError({ ...error, EventDate: true });
    } else {
      setBlog((prev) => ({
        ...prev,
        EventDate: selectedDate,
      }));
      setError({ ...error, EventDate: false });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (!file) {
      // No file selected
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        ValidFile: false,
      }));
      setBlog((prev) => ({
        ...prev,
        Image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      // Valid image file
      setError({ ...error, ValidFile: false });

      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        // Handle too large file
        setBlog((prev) => ({
          ...prev,
          Image: file,
        }));
      } else {
        // File size is okay
        let temp = Blog;
        temp.Image = file;
        setBlog(temp);

        const reader = new FileReader();
        reader.onloadend = () => {
          setBlog((prev) => ({
            ...prev,
            previewUrl: reader.result,
          }));
        };
        reader.readAsDataURL(file);

        document.getElementById("image-name").value = file.name;
      }

      onValidation("Image", e.target.value);
    } else {
      // Invalid file type
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setBlog((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };

  const handleEditorChange = (e) => {
    const newValue = e;

    const strippedValue = newValue
      .replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();
    const sanitizedValue = /^[\s\n]*$/.test(strippedValue);

    if (sanitizedValue) {
      setDescFlag(true);
    } else {
      setDescFlag(false);
      setBlog((prevEvents) => ({
        ...prevEvents,
        Description: newValue,
      }));
    }
  };

  const handleFunctionEditClick = (e) => {
    setTitle(e.child.displayedInName);
    setBlog({
      DisplayedInID: e.parent.displayedInID,
      BlogsID: e.child.blogsID,
      DisplayedInName: e.child.displayedInName,
      BallroomID: e.child.ballroomID,

      Title: e.child.title,
      Description: e.child.description,
      Image: e.child.imagePath,
      OldimagePath: e.child.imagePath,
      EventDate: e.child.eventDate,
    });
    setEditVisible(true);
    const modal = new bootstrap.Modal(document.getElementById("add_Blog"));
    modal.show();
  };

  const refreshChildGrd = () => {
    $(`#reload-Blog`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };

  const handleDeleteClick = async (e) => {
    const onDelete = async () => {
      let SavedBy = sessionUser();
      await corefetch(`Blog/DeleteBlog?blogId=${e.blogsID}`, true, false, true);
      setrefreshflag(refreshflag + 1);
      refreshChildGrd();
    };
    confirmDelete(onDelete);
  };
  function formatEventDate(eventDate) {
    if (!eventDate) return ""; // Return an empty string if there's no date

    // If it's already a Date object, convert to ISO directly
    if (eventDate instanceof Date && !isNaN(eventDate)) {
      return eventDate.toISOString();
    }

    // Try to convert from a string or number to a Date object
    const parsedDate = new Date(eventDate);
    if (!isNaN(parsedDate)) {
      return parsedDate.toISOString();
    }

    // If conversion fails, return an empty string or handle as needed
    return "";
  }

  return (
    <div className="container-fluid">
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Blogs</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">Configuration</li>
              <li className="breadcrumb-item active">Blogs</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="col-auto ms-auto">
        <KendoTreeTable
          name={"Blog"}
          parentTableUrl={CorebaseURL + "Blog/GetDisplayesInList"}
          parentTableColumns={Parentscolumns}
          childTableUrl={
            CorebaseURL +
            "Blog/GetBlogDetailsById?displayedinID={displayedInID}"
          }
          childTableColumns={childColumn}
          onParentEditClick={onEditClick}
          showParentOptions={true}
          showParentDelete={false}
          showChildOptions={true}
          showChildEdit={true}
          showChildDelete={true}
          onChildEditClick={handleFunctionEditClick}
          onChildDeleteClick={handleDeleteClick}
          refreshChildGrd={refreshChildGrd}
          // noteLabel="Note:"
          // noteContent="This module supports drag-and-drop functionality, you can easily
          //         rearrange or move data as needed."
        />

        {/* Add Function Modal */}
        <div
          className="modal custom-modal fade"
          id="add_Blog"
          role="dialog"
          ref={modalRef}
          aria-hidden="true"
          data-bs-backdrop="static"
        >
          <div
            className="modal-dialog modal-dialog-centered blog"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5 className="modal-title">
                  {editVisible
                    ? (title === "BabyShower" ? "Baby Shower" : title) +
                      " - Edit"
                    : (title === "BabyShower" ? "Baby Shower" : title) +
                      " - Add"}
                </h5>

                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearForm}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <form id="blog-form" onSubmit={onSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Title <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Title with a maximum length of 60 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={60}
                        className="form-control"
                        name="Title"
                        value={Blog.Title || ""}
                        placeholder="Title"
                        data-required="true"
                        onChange={(e) => {
                          setBlog((prev) => ({
                            ...prev,
                            Title: e.target.value,
                          }));
                          onValidation("Title", e.target.value);
                        }}
                      />
                      {error.Title && <ErrorMsg text="Title is required" />}
                    </div>

                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="form-label">
                          Upload Image <span className="text-danger">*</span>
                          <InfoIcon
                            content="Kindly upload an Image within 500KB size;
                          Please upload the image in JPEG, JPG or PNG format."
                          />
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          name="file"
                          accept="image/*"
                          onChange={handleFileChange}
                        />

                        {error.Image && <ErrorMsg text=" Image is required" />}
                        {error.ValidFile && (
                          <ErrorMsg text="please upload Image file only" />
                        )}
                        {error.InValidFileSize && (
                          <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                        )}
                      </div>
                      <div className="row mt-1 mb-3">
                        {Blog.OldimagePath && Blog.BlogsID > 0 && (
                          <div
                            style={{
                              width: "100%",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <a
                              href={`${ImageURL}${Blog.OldimagePath}`}
                              target="_blank"
                              style={{
                                textDecoration: "underline",
                                fontSize: "13px",
                              }}
                            >
                              {Blog.OldimagePath.split("/").pop()}
                            </a>
                          </div>
                        )}
                        <input
                          type="hidden"
                          name="Image"
                          id="image-name"
                          data-required="true"
                          value={Blog.Image || ""}
                        />
                        <input
                          type="hidden"
                          name="OldimagePath"
                          value={Blog.OldimagePath}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="eventDate"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Date
                      </label>
                      <KendoDatePicker
                        name="EventDate"
                        value={Blog.EventDate}
                        format="MM/dd/yyyy"
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-12 mb-3">
                      <label>
                        Description <span className="text-danger">*</span>
                      </label>
                      <KendoEditor
                        name="Description"
                        height={"340px"}
                        required={true}
                        // onValidate={onValidation}
                        value={Blog.Description || ""}
                        onChange={handleEditorChange}
                        insertImage={false}
                        createLink={false}
                        unlink={false}
                      />
                      {DescFlag && <ErrorMsg text="Description is required" />}
                    </div>
                    {Loading ? (
                      <KendoLoader className="d-flex justify-content-end align-items-center" />
                    ) : (
                      <div className="text-end">
                        <Button
                          name={"Cancel"}
                          isCancelButton={true}
                          id="blog-cancel"
                          dataBsDismiss={"modal"}
                          onClick={() => {
                            clearForm();
                          }}
                        />
                        <Button name={editVisible ? "Update" : "Save"} />
                      </div>
                    )}
                    <button
                      type="button"
                      id="hide"
                      style={{ display: "none" }}
                      data-bs-dismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    ></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
